import Vue from "vue"
import App from "./App.vue";
import VueProgressiveImage from "vue-progressive-image";
import router from "./router";
const hash = require("object-hash");
const _ = require('lodash');

Vue.use(VueProgressiveImage);
window._ = _;
Vue.prototype.$throttle = _.throttle;
Vue.prototype.$hash = hash;

Vue.config.productionTip = false;

new Vue({
	router,
	render: h => h(App)
}).$mount('#app');